@if (isVisible) {
  <comat-fab-speed-dial
    id="speedDialButton"
    [actions]="speedDialActions"
    (selectedAction)="onFabSpeedDialSelectedAction($event)"
    mainIcon="add"
    color="accent"
    >
  </comat-fab-speed-dial>
} @else {
  <mat-spinner diameter="32"></mat-spinner>
}

